module.exports = __webpack_public_path__ + "static/media/GirlReflectedinKnife_Bookcover.900c45c7.jpg";